import { render, staticRenderFns } from "./headerBlock.vue?vue&type=template&id=c396f16e&scoped=true&"
import script from "./headerBlock.vue?vue&type=script&lang=js&"
export * from "./headerBlock.vue?vue&type=script&lang=js&"
import style0 from "./headerBlock.vue?vue&type=style&index=0&id=c396f16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c396f16e",
  null
  
)

export default component.exports